/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ShootshareconnectcomInputs */

const en_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const es_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const fr_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const de_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const ja_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const zh_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const ar_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const id_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const it_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const ru_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const pt_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

const ko_shootshareconnectcom = /** @type {(inputs: ShootshareconnectcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shootshareconnect.com/`)
};

/**
* | output |
* | --- |
* | "shootshareconnect.com/" |
*
* @param {ShootshareconnectcomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shootshareconnectcom = /** @type {((inputs?: ShootshareconnectcomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ShootshareconnectcomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shootshareconnectcom(inputs)
	if (locale === "es") return es_shootshareconnectcom(inputs)
	if (locale === "fr") return fr_shootshareconnectcom(inputs)
	if (locale === "de") return de_shootshareconnectcom(inputs)
	if (locale === "ja") return ja_shootshareconnectcom(inputs)
	if (locale === "zh") return zh_shootshareconnectcom(inputs)
	if (locale === "ar") return ar_shootshareconnectcom(inputs)
	if (locale === "id") return id_shootshareconnectcom(inputs)
	if (locale === "it") return it_shootshareconnectcom(inputs)
	if (locale === "ru") return ru_shootshareconnectcom(inputs)
	if (locale === "pt") return pt_shootshareconnectcom(inputs)
	return ko_shootshareconnectcom(inputs)
});